/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

function DataTableBodyCell({
  noBorder = false,
  align = "left",
  style,
  styleJourney,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled = false }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={0.3}
      px={1}
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.xs,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        verticalAlign: "middle",
        height: "35px",
        whiteSpace: "nowrap",
        lineHeight: 1,
        "& .MuiCheckbox-root": {
          padding: "0 !important"
        },
        "& .MuiIconButton-root": {
          padding: "2px 0px 0px 0px !important"
        },
        "& .MuiButtonBase-root": {
          minHeight: "unset"
        },
        ...styleJourney,
      })}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ ...style, verticalAlign: "middle", }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  disabled: PropTypes.bool,
};

export default DataTableBodyCell;
